import { REPORT_OPTIONS, matchReport } from "./reportRegistry";

/**
 * Manager bot intents. Reports are NOT listed here — they come from
 * reportRegistry.js, so adding a report never touches this file.
 */
export { REPORT_OPTIONS };

export const QUICK_ACTIONS = [
  { label: "Hotel details", action: "ADMIN_HOTEL_DETAILS" },
  { label: "Reservation", action: "ADMIN_RESERVATION" },
  { label: "Report", action: "ADMIN_REPORT_MENU" },
];

const BASE_RULES = [
  { test: (k) => k.includes("report"), action: "ADMIN_REPORT_MENU" },
  { test: (k) => k.includes("reservation") || k.includes("booking"), action: "ADMIN_RESERVATION" },
  { test: (k) => k.includes("hotel"), action: "ADMIN_HOTEL_DETAILS" },
];

export function matchIntent(text = "") {
  // specific report ("z out report", "zout") beats the generic "report" menu
  const report = matchReport(text);
  if (report) return report;
  const key = text.toLowerCase().replace(/[^a-z0-9]/g, "");
  return BASE_RULES.find((r) => r.test(key))?.action ?? null;
}